<!-- iframe嵌入 - 意见反馈-->
<template>
    <div>
        <iframe :src="src" style="width:100%; height: 1024px;"  frameborder="0" scrolling="no" ></iframe>
    </div>
</template>

<script>
const pathMap = {
  UQ: 'cuh',
  FU: 'fza',
  JD: 'cbj'
}
const airline = window.__MICRO_ROOT__?.airline

export default {
  data () {
    return {
      src: `https://fltnet.hnair.net/crew/pub/complaint/${pathMap[airline]}.do?locale=zh_CN`
    }
  }
}
</script>
